module.exports = __webpack_public_path__ + "static/img/home_banner3.83f05cf5.png";